import { render, staticRenderFns } from "./modalInfoSoporteFinalizado.vue?vue&type=template&id=44f9edd6&scoped=true&"
import script from "./modalInfoSoporteFinalizado.vue?vue&type=script&lang=js&"
export * from "./modalInfoSoporteFinalizado.vue?vue&type=script&lang=js&"
import style0 from "./modalInfoSoporteFinalizado.vue?vue&type=style&index=0&id=44f9edd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f9edd6",
  null
  
)

export default component.exports